import {
  GroupOrderBagCancelButton,
  GroupOrderBagConvertButton,
  GroupOrderBagLeaveButton,
  GroupOrderBagShareButton,
  GroupOrderBagUnlockButton,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagButton = {
  Convert: GroupOrderBagConvertButton,
  Share: GroupOrderBagShareButton,
  Cancel: GroupOrderBagCancelButton,
  Leave: GroupOrderBagLeaveButton,
  Unlock: GroupOrderBagUnlockButton,
};
